module.exports = __webpack_public_path__ + "static/nodegraph-770662238ee57d0305a76dea7e8484d2.png";